import { Icon } from '@iwoca/orion';
import { IconNames } from '@iwoca/orion/lib/components/icon/Icon';
import { clsx } from 'clsx';

import styles from './IconWithText.module.css';

type TProps = {
  icon: IconNames;
  children: React.ReactNode;
  className?: string;
};
const IconWithText = ({ icon, children, className }: TProps) => {
  return (
    <div className={clsx(styles.container, className)}>
      <Icon
        icon={icon}
        height={20}
        width={20}
        className={styles.icon}
        data-testid={`${icon}-icon`}
      />
      <div>{children}</div>
    </div>
  );
};

export default IconWithText;
